import { RadioGroupItem } from '@/components/ui/radio-group';
import { useUserQuery } from '@/hooks/user/queries/use-user.query';
import { PayoutAccountStatus, PayoutMethod } from '@/types/api/payout-account';
import { cn } from '@/utils/shared/Utils';
import { useId } from 'react';
import { PayoutMethodIcon } from './payout-method-icon';
import { formatMobileNumber } from '@/utils/shared/formatters';

interface PayoutAccountListItemProps {
  id: string;
  userId: string;
  groupId: string;
  payoutMethod: PayoutMethod;
  accountName: string;
  status: PayoutAccountStatus;
}

export function PayoutAccountListItem(props: PayoutAccountListItemProps) {
  const { data: user } = useUserQuery(props.userId);
  const id = useId();

  return (
    <div
      className={cn(
        'relative col-span-6 lg:col-span-3 xl:col-span-2 flex items-start gap-2 rounded-lg border border-input p-4 shadow-sm shadow-black/5 has-[[data-state=checked]]:border-ring',
        props.status === PayoutAccountStatus.Active ? 'order-1' : 'order-2',
      )}
    >
      <RadioGroupItem
        value={props.id}
        id={`${id}-1`}
        aria-describedby={`${id}-1-description`}
        className="order-1 after:absolute after:inset-0"
      />
      <div className="flex grow items-start gap-3">
        <PayoutMethodIcon method={props.payoutMethod} />

        <div className="grid grow">
          <div className="flex flex-wrap items-center justify-between mb-0.5">
            <span className="text-sm font-medium text-gray-800 dark:text-gray-100">
              {formatMobileNumber(props.accountName) ?? props.accountName}{' '}
            </span>
          </div>
          <div className="text-sm">{user?.name}</div>
        </div>
      </div>
    </div>
  );
}
